<template>
    <div class="phase_box">
        <!-- 角色切换 -->
        <div class="tab_box">
            <div v-for="(item, index) in tabList" :key="index" @click="tabClick(index)"
                :class="[tabIndex == index ? 'active' : '', 'tab_item']">{{ item }}</div>
        </div>
        <!-- 内容 -->
        <customer-phase v-if="tabIndex == 0"></customer-phase>
        <mill-phase v-if="tabIndex == 1"></mill-phase>
    </div>
</template>
<script>
import CustomerPhase from './components/phaseComponents/CustomerPhase.vue';
import MillPhase from './components/phaseComponents/MillPhase.vue';
export default {
    name: 'phase',
    components:{
        CustomerPhase,
        MillPhase,
    },
    data() {
        return {
            tabIndex: 0,
            tabList: ['客户', '厂家'],
        }
    },
    methods: {
        // tab切换
        tabClick(index) {
            this.tabIndex = index;
        },
    },
}
</script>
<style scoped>
.phase_box {
    padding: 20px;
    margin-top: 20px;
    box-sizing: border-box;
}
.tab_box {
    display: flex;
    width: 200px;
    border: 1px solid #ccc;
}

.tab_item {
    flex:1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}

.active {
    background-color: #1395e0;
    color: #fff;
}
</style>